<div [class]="containerClass">
    <mat-form-field [class]="fieldClass" hideRequiredMarker>
        <mat-label appRemoveAriaOwns>{{ firstDayOfPeriodLabel | translate }} </mat-label>
        <mat-select
            required
            name="annualMonth"
            #annualMonth="ngModel"
            placeholder="{{ firstDayOfPeriodLabel | translate }}"
            [ngModel]="getMonth()"
            (ngModelChange)="selectedMonth = $event; setAnnualModelValuesWithoutDate($event)"
        >
            <mat-option [value]="employeeHireDate">{{ 'time-off-v3.employeeHireDate' | translate }}</mat-option>
            <mat-option *ngFor="let month of months" [value]="month.value">{{ month.label | translate }}</mat-option>
        </mat-select>
    </mat-form-field>

    <div *ngIf="selectedMonth !== employeeHireDate" [class]="containerClass">
        <mat-form-field [class]="fieldClass" hideRequiredMarker>
            <mat-label appRemoveAriaOwns>{{ 'time-off-v3.whichDayOfMonth' | translate }}</mat-label>
            <mat-select
                required
                [ngModel]="getDay()"
                (ngModelChange)="setAnnualModelValuesWithDate($event)"
                (selectionChange)="previewDataChanged()"
                name="dayOfMonth"
                #dayOfMonth="ngModel"
                placeholder="{{ 'time-off-v3.dayOfMonth' | translate }}"
            >
                <mat-option *ngFor="let day of daysPerMonth" [value]="day">{{
                    day > 0 ? (day | ordinalNumber) : ('time-off-v3.lastDay' | translate)
                }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>
